"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZChangePassword = exports.ZPlayerUpdate = exports.ZPlayerSelectPrivateWithHasSocialLogin = exports.ZPlayerSelectPrivate = void 0;
const zod_1 = require("zod");
const zodSchemas_generated_1 = require("../generated/zodSchemas.generated");
const types_1 = require("@daymade/common-lib/types");
exports.ZPlayerSelectPrivate = zodSchemas_generated_1.zodSelectPlayer
    .pick({
    id: true,
    emailAddress: true,
    firstName: true,
    lastName: true,
    phoneNumber: true,
    referralId: true,
    status: true,
    role: true,
    treesPlanted: true,
    avatarLocation: true,
    friendlyName: true,
    interests: true,
    gender: true,
    dateOfBirth: true,
    utmParameters: true,
    abtestVariants: true,
})
    .extend((0, types_1.ensureSubsetOfKeys)(zodSchemas_generated_1.zodSelectPlayer.shape, {
    createdAt: zod_1.z.coerce.date().nullable(),
    updatedAt: zod_1.z.coerce.date().nullable(),
    googleUserId: zod_1.z.string().nullable().optional(),
    facebookUserId: zod_1.z.string().nullable().optional(),
    appleUserId: zod_1.z.string().nullable().optional(),
    dateOfBirth: zod_1.z.coerce.date().nullable(),
    interests: zod_1.z.array(zod_1.z.string()).nullable(),
}));
exports.ZPlayerSelectPrivateWithHasSocialLogin = exports.ZPlayerSelectPrivate.extend({
    hasSocialLogin: zod_1.z.boolean(),
});
exports.ZPlayerUpdate = zodSchemas_generated_1.zodSelectPlayer
    .pick({
    firstName: true,
    lastName: true,
    phoneNumber: true,
    gender: true,
    dateOfBirth: true,
    interests: true,
    avatarLocation: true,
    friendlyName: true,
})
    .extend((0, types_1.ensureSubsetOfKeys)(zodSchemas_generated_1.zodSelectPlayer.shape, {
    emailAddress: zodSchemas_generated_1.zodSelectPlayer.shape.emailAddress.optional(),
    dateOfBirth: zod_1.z.coerce.date().nullable(),
    interests: zod_1.z.array(zod_1.z.string()).nullable(),
}))
    .partial();
exports.ZChangePassword = zod_1.z.object({
    oldPassword: zod_1.z.string(),
    newPassword: zod_1.z.string(),
});
//# sourceMappingURL=models.js.map